import { useMemo } from "react"

import type { GuildEventSignupRecord } from "@/lib/guild-events-api"

import { RosterColumns } from "@/components/guild-events/roster-columns"
import { Badge } from "@/components/ui/badge"
import { Card, CardContent } from "@/components/ui/card"

export function SignupColumnsCard({
  signups,
}: {
  signups: GuildEventSignupRecord[]
}) {
  const grouped = useMemo(() => {
    return {
      attending: signups.filter((signup) => signup.state === "attending"),
      tentative: signups.filter((signup) => signup.state === "tentative"),
      notAttending: signups.filter(
        (signup) => signup.state === "not_attending",
      ),
    }
  }, [signups])

  return (
    <Card>
      <CardContent className="grid gap-4 pt-5 md:grid-cols-3">
        <Column title="Attending" items={grouped.attending} variant="default" />
        <Column
          title="Tentative"
          items={grouped.tentative}
          variant="secondary"
        />
        <Column
          title="Not Attending"
          items={grouped.notAttending}
          variant="outline"
        />
      </CardContent>
    </Card>
  )
}

function Column({
  title,
  items,
  variant,
}: {
  title: string
  items: GuildEventSignupRecord[]
  variant: "default" | "secondary" | "outline"
}) {
  return (
    <div className="grid gap-2 rounded-xl border border-border/70 bg-card/50 p-3">
      <div className="flex items-center justify-between">
        <div className="text-sm font-semibold">{title}</div>
        <Badge variant={variant}>{items.length}</Badge>
      </div>
      <RosterColumns variant="admin" signups={items} />
    </div>
  )
}
